import React, { useEffect, useState } from 'react';
import { Alert, Spin } from 'antd';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { getWarrantyPackageByLegacyPeriod } from 'services/warranty-package.service';

const WarrantyPeriodLegacyRedirect = () => {
  const { warranty_period_id } = useParams();
  const { pathname } = useLocation();
  const history = useHistory();
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setError(null);
    getWarrantyPackageByLegacyPeriod(warranty_period_id)
      .then((value) => {
        const packageId = Number(value?.warranty_package_id);
        if (!Number.isSafeInteger(packageId) || packageId <= 0) throw new Error('Không tìm thấy gói từ thời hạn bảo hành cũ.');
        if (active) history.replace(`/warranty-package/${pathname.includes('/detail/') ? 'detail' : 'edit'}/${packageId}`);
      })
      .catch((failure) => { if (active) setError(failure?.message || 'Không tải được gói từ thời hạn bảo hành cũ.'); });
    return () => { active = false; };
  }, [history, pathname, warranty_period_id]);

  return <div className='bw_main_wrapp'>
    {error ? <Alert type='error' showIcon message={error} /> : <Spin tip='Đang mở gói bảo hành từ khai báo cũ...' />}
  </div>;
};

export default WarrantyPeriodLegacyRedirect;
